import styled from 'styled-components';
import { fontSize } from 'theme';

const Root = styled.div`
  background-color: #fff1bf;
  color: #433f52;
  padding: 2rem;
  font-size: ${fontSize('md')};
  border-radius: 24px;
`;

export const CardHighlight01Styles = {
  Root
};
